import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import moduleValidation from './moduleValidation';
import * as moduleActions from 'redux/modules/modules';

import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({
    saveError: state.modules.saveError
  }),
  dispatch => bindActionCreators(moduleActions, dispatch)
)
@reduxForm({
  form: 'module',
  fields: ['id', 'name'],
  validate: moduleValidation
})
export default class ModuleForm extends Component {


  render() {
    const { editStop, fields: { id, name }, formKey, handleSubmit, invalid,
      pristine, save, submitting, saveError: { [formKey]: saveError }, values } = this.props;
    const styles = require('containers/Modules/Modules.scss');
    return (
      <tr className={submitting ? styles.saving : ''}>
        <td className={styles.idCol}>{id.value}</td>
        <td className={styles.sprocketsCol}>
          <input name="username" type="text" className="form-control" {...name} />
          {name.error && name.touched && <div className="text-danger">{name.error}</div>}
        </td>

        <td className={styles.buttonCol}>
          <button className="btn btn-default"
            onClick={() => editStop(formKey)}
            disabled={submitting}>
            <i className="fa fa-ban" /> Annuler
          </button>&nbsp;
          <button className="btn btn-success"
            onClick={handleSubmit(() =>
              save(values)
                .then(result => {
                  if (result && typeof result.error === 'object') {
                    return Promise.reject(result.error);
                  }
                })
            )}
            disabled={pristine || invalid || submitting}>
            <i className={'fa ' + (submitting ? 'fa-cog fa-spin' : 'fa-cloud')} /> Modifier
          </button>
          {saveError && <div className="text-danger">{saveError}</div>}
        </td>
      </tr>
    );
  }
}
